import { getAppidApi, getUserInfoApi } from '../../api/app'
import wx from 'weixin-js-sdk'
import { getOpenId, setOpenId, getStudentId, setStudentId, getNickName, setNickName, getName, setName, getGender, setGender , getAvatar , setAvatar} from '../../utils/auth'
import Vue from "vue"
import { Toast } from 'vant';
Vue.use(Toast);
const state = {
  openId: getOpenId() || "", //用户id
  avatar: getAvatar() || "",
  studentId: getStudentId() || "", //学生id
  nickName: getNickName() || "", //家长姓名
  studentName: getName() || "", //学生姓名
  gender: getGender() || "", //学生性别
}

const mutations = {
  SET_OPENID(state, data) {
    state.openId = data
    setOpenId(data)
  },
  SET_STUDENTID(state, data) {
    console.log(data)
    state.studentId = data
    setStudentId(data)
  },
  SET_NICKNAME(state, data) {
    state.nickName = data
    setNickName(data)
  },
  SET_NAME(state, data) {
    state.studentName = data
    setName(data)
  },
  SET_GENDER(state, data) {
    state.gender = data
    setGender(data)
  },
  SET_AVATAR(state, data) {
    state.avatar = data
    setAvatar(data)
  }
}

const actions = {
  async getUserInfo({ commit, state }) {
    let r = await getUserInfoApi()
    // Toast(r.data.user.openId)
    if (r.data.student) {
      if (typeof r.data.student.studentId == 'object' && r.data.student.studentId.c) {
        id = r.data.student.studentId.toString()
        commit('SET_STUDENTID', id)
        commit('SET_NAME', r.data.student.name)
        commit('SET_GENDER', r.data.student.gender)
      } else {
        commit('SET_STUDENTID', r.data.student.studentId)
        commit('SET_NAME', r.data.student.name)
        commit('SET_GENDER', r.data.student.gender)
      }
    }
    commit('SET_NICKNAME', r.data.user.nickname)
    commit('SET_OPENID', r.data.user.openId)
    commit('SET_AVATAR', r.data.user.avatar)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
